import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/heatmap";
import * as types from "./types";
import * as actions from "./actions";
import { EMPTY_HEATMAP_COUNTS } from "./reducer";
import { showErrorMsg } from "../../utils/Helpers";

// Fetch Heatmap Data
function* fetchHeatmapSaga({ payload }) {
  try {
    const response = yield call(apis.getEventHeatmap, payload);
    yield put(
      actions.fetchHeatmapSuccess({
        data: response.data.data || [],
        counts: response.data.counts || EMPTY_HEATMAP_COUNTS,
      })
    );
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to load heatmap";
    yield put(actions.fetchHeatmapFailure(errorMessage));
    yield call(showErrorMsg, errorMessage);
  }
}

// Watcher Saga
export default function* HeatmapSagas() {
  yield takeEvery(types.FETCH_HEATMAP_REQUEST, fetchHeatmapSaga);
}
